import { getCookie, setCookie } from './cookie';
import { isLocalStorageAvailable } from './localStorage';

export default function updateAuthToken(headers) {
    if (
        headers &&
        headers['auth-token']
    ) {
        switch (isLocalStorageAvailable()) {
            case true:
                if (headers['auth-token'] !== window.localStorage.getItem('auth-token')) {
                    window.localStorage.setItem('auth-token', headers['auth-token']);
                }
                break;
            case false:
                if (headers['auth-token'] !== getCookie('auth-token')) {
                    const date = new Date();

                    date.setDate(date.getDate() + 1);
                    setCookie(
                        `auth-token=${headers['auth-token']}; ` +
                        `domain=.${location.host.split('.').slice(1).join('.')}; ` +
                        'path=/; ' +
                        `expires=${date.toUTCString()}`);
                }
                break;

            // no default
        }
    }
}



// WEBPACK FOOTER //
// /src/js/common/utils/updateAuthToken.js